import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import {
  BsModalRef,
  BsModalService,
} from 'ngx-bootstrap/modal';
import {
  InfoPageDialogComponent,
  InfoPageTemplate,
} from 'src/app/components';
import { FormFieldAbstractComponent } from 'src/app/lib/form-fields/form-field-abstract.component';
import { TranslateParameters } from 'src/app/types/TranslateParameters';

@Component({
  selector: 'app-form-field-checkbox-terms-of-service',
  templateUrl:
    './form-field-checkbox-terms-of-service.component.html',
  styleUrls: [
    './form-field-checkbox-terms-of-service.component.scss',
  ],
  encapsulation: ViewEncapsulation.None,
})
export class FormFieldCheckboxTermsOfServiceComponent
  extends FormFieldAbstractComponent
  implements AfterViewInit
{
  modalRef?: BsModalRef;

  @Input() focused = false;
  @Input() translateParameters!: TranslateParameters;

  @ViewChild('autoFocusInput')
  autoFocusInputRef!: ElementRef<HTMLInputElement>;

  constructor(private modalService: BsModalService) {
    super();
  }

  ngAfterViewInit(): void {
    if (this.focused && this.autoFocusInputRef) {
      setTimeout(() => {
        this.autoFocusInputRef.nativeElement.focus();
      }, 0);
    }
  }

  preventClick(e: Event) {
    e.preventDefault();
    e.stopPropagation();
  }

  openDialog(pageTemplate: InfoPageTemplate): void {
    this.modalRef = this.modalService.show(
      InfoPageDialogComponent,
      {
        class: 'modal-lg',
        initialState: {
          template: pageTemplate,
        },
      }
    );
  }

  get checkBoxLabel(): string {
    return this.label;
  }

  get showError(): boolean {
    return this.field.touched && !this.field.valid;
  }

  get hasHint(): boolean {
    return null !== this.hint && !this.showError;
  }
}
